import { render, staticRenderFns } from "./user-verification-modal.vue?vue&type=template&id=6e9e2cfd&scoped=true&"
import script from "./user-verification-modal.vue?vue&type=script&lang=js&"
export * from "./user-verification-modal.vue?vue&type=script&lang=js&"
import style0 from "./user-verification-modal.vue?vue&type=style&index=0&id=6e9e2cfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9e2cfd",
  null
  
)

component.options.__file = "user-verification-modal.vue"
export default component.exports